import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader2Icon } from 'lucide-react';
import { AdminDataProvider, useAdminData } from './contexts/AdminDataContext';
import { AdminShell } from './components/admin/AdminShell';
import { PublicSite } from './pages/PublicSite';
import { AdminLogin } from './pages/admin/AdminLogin';
import { Overview } from './pages/admin/Overview';
import { Enquiries } from './pages/admin/Enquiries';
import { Quotes } from './pages/admin/Quotes';
import { QuoteNew } from './pages/admin/QuoteNew';
import { QuoteDetail } from './pages/admin/QuoteDetail';
import { Cases } from './pages/admin/Cases';
import { CaseNew } from './pages/admin/CaseNew';
import { CaseDetail } from './pages/admin/CaseDetail';
import { Invoices } from './pages/admin/Invoices';
import { InvoiceDetail } from './pages/admin/InvoiceDetail';
import { Customers } from './pages/admin/Customers';
import { CustomerDetail } from './pages/admin/CustomerDetail';
import { Settings } from './pages/admin/Settings';
import { company } from './data/site';
import { applyBrandIcon } from './utils/favicon';
import { initAnalytics } from './utils/analytics';
function RequireAdmin({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    loggedIn,
    authLoading
  } = useAdminData();
  if (authLoading) {
    return <div className="flex min-h-screen w-full items-center justify-center bg-canvas" data-id="element-0" data-mp="56nfhsbnbo2">
        <p className="flex items-center gap-2 text-[15px] text-ink-muted" data-id="element-1" data-mp="2zmem63p09c5e">
          <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-2" data-mp="33lx02fiesmyq" />
          Henter …
        </p>
      </div>;
  }
  if (!loggedIn) return <Navigate to="/admin/login" replace data-id="element-3" data-mp="38nuqbtp88i16" />;
  return <>{children}</>;
}
export function App() {
  useEffect(() => {
    applyBrandIcon(company.logoMark, 'Lykkeværk');
    void initAnalytics();
  }, []);
  return <AdminDataProvider data-id="element-4" data-mp="nxwvhfx3tat2">
      <BrowserRouter data-id="element-5" data-mp="su45bjsmf6ga">
        <Routes data-id="element-6" data-mp="stkns46vuk2s">
          <Route path="/" element={<PublicSite data-id="element-8" data-mp="swq8z8ce51t8" />} data-id="element-7" data-mp="st2iyj65mxj9" />
          <Route path="/admin/login" element={<AdminLogin data-id="element-10" data-mp="356rv4texg92" />} data-id="element-9" data-mp="3688dot76uy6" />
          <Route path="/admin" element={<RequireAdmin data-id="element-12" data-mp="3ubzsa6gdtbcj">
                <AdminShell data-id="element-13" data-mp="3uevsk1fpcc45" />
              </RequireAdmin>} data-id="element-11" data-mp="38kxclxdi5kq">
            <Route index element={<Overview data-id="element-15" data-mp="d2l6qzzotwz9" />} data-id="element-14" data-mp="d45uo6rhyho5" />
            <Route path="henvendelser" element={<Enquiries data-id="element-17" data-mp="86w76wno4g2y" />} data-id="element-16" data-mp="85ukfuxai55e" />
            <Route path="tilbud" element={<Quotes data-id="element-19" data-mp="3gl4sdjnv24l3" />} data-id="element-18" data-mp="83i2vivg1wsv" />
            <Route path="tilbud/ny" element={<QuoteNew data-id="element-21" data-mp="3glo0k8nplelx" />} data-id="element-20" data-mp="3gmfw5jhb3cc7" />
            <Route path="tilbud/:quoteId" element={<QuoteDetail data-id="element-23" data-mp="3bncpxvplb02n" />} data-id="element-22" data-mp="3bmbehq4nwbke" />
            <Route path="sager" element={<Cases data-id="element-25" data-mp="3qb7i9azor2f7" />} data-id="element-24" data-mp="3bo4mp9uxb3ui" />
            <Route path="sager/ny" element={<CaseNew data-id="element-27" data-mp="3qcr0360zplj3" />} data-id="element-26" data-mp="3qbpl4qgusew3" />
            <Route path="sager/:caseId" element={<CaseDetail data-id="element-29" data-mp="3ljxu6etsc75f" />} data-id="element-28" data-mp="3qdag2h72xzuh" />
            <Route path="fakturaer" element={<Invoices data-id="element-31" data-mp="3liehszb92g8x" />} data-id="element-30" data-mp="3ljpk0up1rfxx" />
            <Route path="fakturaer/:invoiceId" element={<InvoiceDetail data-id="element-33" data-mp="2xtbyln0ywfcb" />} data-id="element-32" data-mp="2xumznf3138zq" />
            <Route path="kunder" element={<Customers data-id="element-35" data-mp="2swbtpffutims" />} data-id="element-34" data-mp="2xsk3edba8jmk" />
            <Route path="kunder/:customerId" element={<CustomerDetail data-id="element-37" data-mp="2stzakyyd1285" />} data-id="element-36" data-mp="2sv0qbgqbmcw7" />
            <Route path="indstillinger" element={<Settings data-id="element-39" data-mp="18cgflw44u7mp" />} data-id="element-38" data-mp="18dhq9zh8ks3w" />
          </Route>
          <Route path="*" element={<Navigate to="/" replace data-id="element-41" data-mp="1d5jbiawdtt62" />} data-id="element-40" data-mp="1d47ydkh1r92a" />
        </Routes>
      </BrowserRouter>
    </AdminDataProvider>;
}